import {bff} from '../bff'

export function useCountryPlans() {
    const {data, isLoading, error} = bff.paywall.plans.getSubscriptionAndPlansInfo.useQuery()

    return {
        data,
        isLoading,
        error,
    }
}
